module.exports = __webpack_public_path__ + "img/30.c23a94ac.png";